import { connect } from "react-redux";
import RateType from "../components/Rate/Type";

const RateTypePage = ({ accessToken, currentLang }) => {
  return <RateType accessToken={accessToken} currentLang={currentLang} />;
};

function mapStateToProps({ auth, lang }) {
  return {
    auth,
    accessToken: auth.token.accessToken,
    currentLang: lang.currentLang,
  };
}

export default connect(mapStateToProps, null)(RateTypePage);
